import { realEstateFields } from "./categories/RealEstate";
import { transportFields } from "./categories/Transport";
import { gadgetsFields } from "./categories/Gadgets";
import { careerFields } from "./categories/Career";
import { servicesFields } from "./categories/Services";
import { homeComfortFields } from "./categories/HomeComfort";
import { gardenFields } from "./categories/Garden";
import { kidsFields } from "./categories/Kids";
import { petsFields } from "./categories/Pets";
import { fashionFields } from "./categories/Fashion";
import { sportsFields } from "./categories/Sports";
import { beautyFields } from "./categories/Beauty";
import { educationFields } from "./categories/Education";
import { rentalFields } from "./categories/Rental";
import { partsFields } from "./categories/Parts";
import { accessoriesFields } from "./categories/Accessories";
import { foodFields } from "./categories/Food";
import { hobbyFields } from "./categories/Hobby";

const categoryFieldsConfig = {
  "Житло та нерухомість": realEstateFields,
  "Транспорт": transportFields,
  "Гаджети": gadgetsFields,
  "Карʼєра": careerFields,
  "Майстри та послуги": servicesFields,
  "Дім та затишок": homeComfortFields,
  "Для саду та подвір'я": gardenFields,
  "Малеча": kidsFields,
  "Домашні улюбленці": petsFields,
  "Стиль": fashionFields,
  "Активність та спорт": sportsFields,
  "Б’юті": beautyFields,
  "Знання та Навчання": educationFields,
  "Оренда та прокат": rentalFields,
  "Запчастини та аксесуари": partsFields,
  "Аксесуари": accessoriesFields,
  "Продукти та їжа": foodFields,
  "Хобі": hobbyFields,
};

export default categoryFieldsConfig;
